import React, { useState } from 'react';
import classNames from 'classnames';

import { TYPES, EVENTS } from 'constants/config';
import Step from '../Content/Step';
import CollapsedTitle from './CollapsedTitle';
import Content from '../Content';
import CompletedContent from '../CompletedContent';
import CompletedPath from '../CompletedPath';

const typesToComponent = {
  [TYPES.PATH]: CompletedPath,
  [TYPES.LESSON]: CompletedContent,
  [TYPES.RESOURCE]: Content,
};

const ContentRenderer = ({ content }) => {
  const Component = typesToComponent[content.type];

  return <Component {...content} />;
};

export default function CollapsedContent({
  collapsedContent,
  totalSteps,
  isCertification,
  hasHiddenContents,
}) {
  const firstContent = collapsedContent[0];
  const [isExpanded, setIsExpanded] = useState(false);

  const onContentClick = () => {
    global.pubsub.publish(EVENTS.SET_STEP_CONNECTOR_POSITION);
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="CollapsedContentWrapper">
      <article
        className={classNames('PathContentWrapper', {
          'PathContentWrapper--expanded': isExpanded,
        })}
      >
        <div className="w-fill">
          <CollapsedTitle
            onClick={onContentClick}
            collapsed={collapsedContent}
            totalSteps={totalSteps}
            isExpanded={isExpanded}
            isCertification={isCertification}
            hasHiddenContents={hasHiddenContents}
          />
          <Step
            id={firstContent.id}
            stepNumber={firstContent.stepNumber}
            progress={firstContent.progress}
            collapsed
          />
        </div>
      </article>
      {isExpanded &&
        collapsedContent.map(content => (
          <ContentRenderer
            key={`${content.type}.${content.id}`}
            content={content}
          />
        ))}
    </div>
  );
}
